module.exports = __webpack_public_path__ + "static/media/login_banner.c8b6752f.png";